import type { Database } from '@repo/supabase'

export type InvestmentStatus = Database['public']['Enums']['investment_status']

// Etykiety statusu inwestycji (te same pojęcia co portfolio widget).
export const INVESTMENT_STATUS_LABELS: Record<InvestmentStatus, string> = {
  w_trakcie_sprzedazy: 'W sprzedaży',
  wkrotce: 'Wkrótce',
  oddane: 'Oddane',
}

export function investmentStatusLabel(status: InvestmentStatus | null | undefined): string {
  return status ? INVESTMENT_STATUS_LABELS[status] : '—'
}

// Kolory statusu — te same co portfolio-widget TemplateMap (bg + tekst).
interface StatusColor {
  bg: string
  text: string
}

export const INVESTMENT_STATUS_COLORS: Record<InvestmentStatus, StatusColor> = {
  w_trakcie_sprzedazy: { bg: '#2d7a4a', text: '#ffffff' },
  wkrotce: { bg: '#c4954a', text: '#1a1a1a' },
  oddane: { bg: '#1f3159', text: '#ffffff' },
}

const STATUS_COLOR_FALLBACK: StatusColor = { bg: '#e0e0e0', text: '#1a1a1a' }

export function investmentStatusColor(status: InvestmentStatus | null | undefined): StatusColor {
  return status ? INVESTMENT_STATUS_COLORS[status] : STATUS_COLOR_FALLBACK
}
